import * as React from "react";
import cx from "classnames";
import { CustomScrollbar } from "../../../components";

import "./Suggestions.css";

export interface SuggestionsProps {
  shown: boolean;
  children?: JSX.Element[] | JSX.Element;
}

const Suggestions = (props: SuggestionsProps) =>
  <div className="product-suggestions__container">
    <div
      className={cx("product-suggestions", {
        "product-suggestions--hidden": !props.shown,
      })}
    >
      <CustomScrollbar minHeight={100} maxHeight={300}>
        <ul className="product-suggestions__list">
          {props.children}
        </ul>
      </CustomScrollbar>
    </div>
  </div>;

export default Suggestions;



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/components/Suggestions.tsx